import { useAuth } from '@/contexts/AuthContext';
import { TeamRole } from '@/types/roles';

export const useRoleAccess = () => {
  const { user } = useAuth();

  const isSuperAdmin = user?.teamRole === 'super_admin';
  const isAdmin = user?.teamRole === 'admin' || isSuperAdmin;
  const isViewer = user?.teamRole === 'viewer';

  // Feature access controls
  const canGenerateApiKeys = isAdmin;
  const canExportReports = isAdmin;
  const canDeleteReports = isAdmin;
  const canInviteMembers = isAdmin;
  const canAccessSettings = isAdmin;
  const canManageTeam = isAdmin;
  const canAccessAuditLogs = isAdmin;

  return {
    isSuperAdmin,
    isAdmin,
    isViewer,
    canGenerateApiKeys,
    canExportReports,
    canDeleteReports,
    canInviteMembers,
    canAccessSettings,
    canManageTeam,
    canAccessAuditLogs,
    userRole: (user?.teamRole || 'viewer') as TeamRole
  };
}; 